import { render } from "./merchantView.vue?vue&type=template&id=47a3abee&scoped=true"
import script from "./merchantView.vue?vue&type=script&lang=js"
export * from "./merchantView.vue?vue&type=script&lang=js"

import "./merchantView.vue?vue&type=style&index=0&id=47a3abee&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a3abee"]])

export default __exports__